<template lang="pug">
    .col-span-6
        label.block.text-sm.font-medium.text-gray-700(
            :for="'field_' + parameter.id"
            :class="{ 'required': parameter['required'] }")
            | {{ parameter.name }}
        .item-form-parameter-field-input__wrapper.-m-1.p-1(
            :id="'field_' + parameter.id"
            :class="{ 'is-invalid': error }")
            input(type='text' ref='slider-input'
                class='mt-1 block w-full shadow-sm border-gray-300'
                +' rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm')
        p.mt-2.p-1.rounded.text-sm.text-red-500.bg-gray-100(v-if='error')
            | {{ error.message || 'Поле обязательно для заполнения' }}
</template>

<script>
import $ from 'jquery'
import ionRangeSlider from 'ion-rangeslider'
import store from 'js@/store'
import {getDigits} from 'help@/slider'
import {mapState} from 'vuex'

export default {
    name: 'ItemFormGroupParameterSlider',

    store,

    props: {
        parameter: {
            type: Object,
        },

        value: {
            type: [String, Number],
        },

        error: {
            type: [Object, Boolean],
        },
    },

    data () {
        return {
            target: false,
            slider: {
                instance: {},
                params: {},
                input: {},
                scale: [],
            }
        }
    },

    computed: {
        ...mapState({
            isMobile: state => state.item.isMobile,
        })
    },

    watch: {
        isMobile(value) {
            this.slider.instance.data("ionRangeSlider").update({
                grid: !value,
            })
        }
    },

    mounted () {
        if (this.parameter.hasOwnProperty('extra_serialized')) {
            // this.slider.params = JSON.parse(this.parameter.extra_serialized)
            this.slider.params = this.parameter.extra_serialized
            this.slider.scale = this.getScale()
            const self = this
            this.sliderOptions = {
                values: this.slider.scale,
                grid: !this.isMobile,
                skin: 'big',
                onChange: function (data) {
                    let value = /^[\d.]+/.exec(data.from_value)
                    value = (value) ? value[0] : 'false'
                    self.$emit(
                        'input',
                        value,
                    )
                },
            }

            this.slider.input = $(this.$refs['slider-input'])
            this.slider.instance = this.slider.input.ionRangeSlider(
                this.sliderOptions
            )

            if (this.value) {
                let target
                if (this.parameter.hasOwnProperty('unit') && this.parameter.unit.length > 0) {
                    target = `${this.value} ${this.parameter['unit']}`
                } else {
                    target = Number(this.value)
                }

                const sliderInstance = this.slider.instance.data("ionRangeSlider")
                sliderInstance.update({
                    from: this.slider.scale.indexOf(target),
                })
            }
        }
    },

    methods: {
        getScale: function () {
            const unit = (this.parameter['unit']) ? this.parameter['unit'] : ''
            let suffix = (unit) ? unit : ''
            if (this.slider.params.hasOwnProperty('values')) {
                return this.makeScale(
                    this.slider.params['values'],
                    suffix,
                )
            } else if (this.slider.params.hasOwnProperty('special')) {
                return this.makeScale(
                    this.slider.params.special.substring(
                        1,
                        this.slider.params.special.length - 1
                    ).split(","),
                    suffix,
                )
            }
            return this.makeSpecialScale(this.slider.params, suffix)
        },

        makeScale (
            values = [],
            suffix = '',
            scale = ['Нет']) {
            for (const value of values) {
                if (suffix) {
                    scale.push(`${value} ${suffix}`)
                } else {
                    scale.push(value)
                }
            }
            return scale
        },

        makeSpecialScale: function (params, suffix = '', scale = ['Нет']) {
            let min = parseFloat(params['minimum'])
            let max = parseFloat(params['maximum'])
            const step = parseFloat(params['step'])
            let reverse = false
            if (max < min) {
                [min, max] = [max, min]
                reverse = true
            }

            while (min <= max) {
                if (suffix) {
                    scale.push(`${min} ${suffix}`)
                } else {
                    scale.push(min)
                }

                if (min % 1 === 0) {
                    min += step
                } else {
                    min = Number((min + step).toFixed(getDigits(step)))
                }
            }

            if (reverse) {
                scale = scale.reverse()
                scale.unshift(scale.pop())
            }

            return scale
        },

    },
}
</script>

<style lang="sass">
@import "../../../node_modules/ion-rangeslider/css/ion.rangeSlider.min.css"

.item-form-parameter-field-input__wrapper
    border-radius: 0.25rem
    border: 1px solid #fff
    &.is-invalid
        border-color: red
</style>
